<template>
    <div style="border: 1px solid #ccc;z-index: 999;">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig"
            :mode="mode" />
        <Editor style="height: 500px; overflow-y: hidden;" v-model="valueHtml" :defaultConfig="editorConfig"
            :mode="mode" @onCreated="handleCreated" @onChange="onChange"/>
    </div>
</template>

<script lang="ts" setup>
import { ConstantField } from '@/constant/ConstantField';
import { Action } from '@/typeDefine/CommonTypes';
import { IEditorConfig, IToolbarConfig } from '@wangeditor-next/editor';
import { Editor, Toolbar } from '@wangeditor-next/editor-for-vue'
import { ElMessage } from 'element-plus';
import { onBeforeUnmount, Ref, ref, shallowRef, toRef, watch } from 'vue'

export interface EditorComponentType {
    clear: Action,
    setHtml: Action<[string]>
    editorReadyAsync: Promise<void>
}

const props = defineProps<{
    mode: 'default' | 'simple',
    placeholder: string
    disabled?: boolean
}>()

const editorRef = shallowRef()
const emit = defineEmits<{
    onChange: [string]
    onCreated: []
}>()
const valueHtml = defineModel<string>('valueHtml')

const toolbarConfig: Partial<IToolbarConfig> = {
    excludeKeys: [
        'group-video', // 去掉视频
        'codeBlock',    // 去掉代码块
        'blockquote',   // 去掉引用
        'todo',         // 去掉 todo 列表
        'code'
    ]
}
const editorConfig: Partial<IEditorConfig> = { 
    placeholder: props.placeholder,
    readOnly: props.disabled,
    MENU_CONF: {
        uploadImage: {
            fieldName: 'image',
            server: `${ConstantField.SERVER}/news/admin/uploadImage`,
            withCredentials: true,
            base64LimitSize: 0,
            metaWithUrl: false,
            allowedFileTypes: ['image/*'],
            maxFileSize: 1024 * 1024 * 256,
            onSuccess: (file: any, res: any) => {
                
            },
            onFailed: (file: any, res: any) => {
                ElMessage({
                    type: 'error',
                    message: res.message
                })
            },
            onError: (file: any, err: any, res: any) => {
                ElMessage({
                    type: 'error',
                    message: res.message
                })
            },
            customInsert(res, insertFn) {

                insertFn(`${res?.data?.url}`)
            },
        }
    }
}

let editorResolve: Action<[any],void>

const handleCreated = (editor: any) => {
    editorRef.value = editor

    emit('onCreated')
    editorResolve(editor)
}

const editorReadyAsync = new Promise<any>(resolve => {
    editorResolve = resolve
})

const onChange: Action<[any]> = (v:any) => {
    emit('onChange',v.getText().trim())
}

//清空内容
const clear: Action = () => {
    editorRef.value?.clear()
}

//设置指定html
const setHtml: Action<[string]> = (html: string) => {
    editorRef.value?.setHtml(html)
}

watch(() => props.disabled,(val: boolean) => {
    if(editorRef.value) {
        val ? editorRef.value.disable() : editorRef.value.enable()
    }
})


onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

defineExpose<EditorComponentType>({
    clear,
    setHtml,
    editorReadyAsync
})

</script>

<style lang="css" scoped></style>